import UserPreferenceSingleton from '../helpers/UserPreferenceSingleton';
import LocalDbService, { EMAIL_ACCOUNTS_TABLE_NAME, UPDATE_ON_ID } from './localDbService';

let singleton;
let organizationId;

export default class EmailAccountCacheService extends LocalDbService {
  constructor(props) {
    const db_name = `${props.organizationId}`;
    props.dbName = db_name;
    props.tableName = EMAIL_ACCOUNTS_TABLE_NAME;
    super(props);
  }

  static getInstance() {
    const org = UserPreferenceSingleton.getInstance().getOrganization();
    if (org) {
      if (!singleton || organizationId !== org.id) {
        organizationId = org.id;
        singleton = new EmailAccountCacheService({ organizationId: org.id });
      }
    }
    return singleton;
  }

  static removeInstance() {
    if (singleton) singleton.closeDb();
    organizationId = undefined;
    singleton = undefined;
  }

  async getEmailAccounts() {
    const result = await this.get();
    return result;
  }

  async setEmailAccounts(value) {
    if (!value) return false;
    const result = await this.addBulk(value);
    return result;
  }

  async updateEmailAccounts(newList, archivedList) {
    const result = await this.syncList(newList, archivedList);
    return result;
  }

  async updateEmails(newList, archivedList) {
    const result = await this.syncList(newList, archivedList);
    return result;
  }

  async getLastUpdatedTime() {
    const result = await super.getLastUpdatedTime(UPDATE_ON_ID.EMAIL_ACCOUNTS);
    return result;
  }

  async setLastUpdatedTime(value) {
    const result = await super.setLastUpdatedTime(UPDATE_ON_ID.EMAIL_ACCOUNTS, value);
    return result;
  }
}
